import moment from 'moment';

import { ReactComponent as CheckmarkIcon } from '../../../resources/checkmark.svg';
import { ReactComponent as CrossIcon } from '../../../resources/cross.svg';
import HealtheraTable from '../../Table/Table';
import LoadingCell from '../components/Loading/LoadingCell';

const ServiceConditions = ({
  conditions,
  onRowsPerPageChange,
  onPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  total,
  isLoading,
}) => {
  const preparedData = isLoading
    ? prepareLoadingData(rowsPerPage)
    : prepareData({ conditions });

  return (
    <HealtheraTable
      data={preparedData}
      muted
      totalCount={total}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onChangePage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      displayPagination
    />
  );
};

const headers = {
  view: {
    internal_name: { title: 'Condition Name', width: '25%' },
    description: { title: 'Description', width: '20%' },
    date_modified: { title: 'Date created/amended', width: '20%' },
    services: { title: 'Services allocated', width: '20%' },
    questionnaire: { title: <div style={{ textAlign: 'center' }}>Questionnaire attached</div>, width: '15%' },
  },
  headers: true
};

const prepareLoadingData = (rowsPerPage) => {
  return Array.from({ length: rowsPerPage }).reduce(
    data => {
      data.push({
        view: {
          internal_name: <LoadingCell />,
          description: <LoadingCell />,
          date_modified: <LoadingCell />,
          services: <LoadingCell />,
          questionnaire: <LoadingCell />,
        }
      });
      return data;
    },
    [headers]
  );
};

const prepareData = ({ conditions }) => {
  if (!conditions) {
    return [];
  }

  const rows = conditions.map((condition) => {
    const { _id, internal_name, description_short, date_modified, services, questionnaire_id } = condition;

    return {
      view: {
        internal_name,
        description: description_short,
        date_modified: moment(date_modified).format('ddd, MMM DD, YYYY hh:mm A'),
        services: services?.join(', '),
        questionnaire: (
          <div style={{ width: '100%', textAlign: 'center' }}>
            {Boolean(questionnaire_id) ? <CheckmarkIcon /> : <CrossIcon />}
          </div>
        ),
      },
      ID: _id,
      route: 'services/conditions'
    };
  });

  return [headers, ...rows];
};

export default ServiceConditions;
